import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'notif-success',
  templateUrl: './notif-success.component.html',
  styleUrls: ['./notif-success.component.css']
})
export class NotifSuccessComponent implements OnInit {

  @Input() msg : string;
  @Input() closable : string;
  constructor() { }

  ngOnInit() {
  }

}
